<header class="h-21 px-2 md:px-4.5 flex items-center justify-between bg-primary-700">
  <svg-icon
    src="assets/svg/logo-white.svg"
    [svgStyle]="{ 'height.px': 38, width: 'auto' }"
  ></svg-icon>

  <!-- <ul
    nz-menu
    nzMode="horizontal"
    nzTheme="dark"
    class="flex-1 md:flex gap-2 justify-center items-center !bg-[#fff0] border-0 hidden"
  >
    @for (nav of menuList(); track $index) {
      @if (nav.subMenuList && nav.subMenuList.length > 0) {
        <li nz-submenu [nzTitle]="titleTemplate">
          <ng-template #titleTemplate>
            <a class="flex gap-3 items-center min-w-10 min-h-10">
              <svg-icon [src]="nav.icon"></svg-icon>
              <span>{{ nav.name }}</span>
            </a>
          </ng-template>

          <ul>
            @for (item of nav.subMenuList; track $index) {
              <li
                nz-menu-item
                [nzMatchRouterExact]="item.exact"
                nzMatchRouter
                class=""
              >
                <a
                  [routerLink]="item.link"
                  [queryParams]="item.queryParams"
                  class="flex gap-3 items-center min-w-10 min-h-10"
                >
                  <svg-icon [src]="item.icon"></svg-icon>
                  <span>{{ item.name }}</span>
                </a>
              </li>
            }
          </ul>
        </li>
      } @else {
        <li
          nz-menu-item
          [nzDanger]="nav.type === 'Danger'"
          [nzMatchRouterExact]="nav.exact"
          nzMatchRouter
        >
          <a
            [routerLink]="nav.link"
            [queryParams]="nav.queryParams"
            class="flex gap-3 items-center min-w-10 min-h-10"
          >
            <svg-icon
              [src]="nav.icon"
              [svgStyle]="{ 'width.px': 24 }"
            ></svg-icon>
            <span>{{ nav.name }}</span>
          </a>
        </li>
      }
    }
  </ul> -->

  <div [ngClass]="{ 'flex items-center justify-end gap-6': true }">
    <a [routerLink]="'/admin/notifications'" class="flex items-center gap-2">
      <span class="rounded-full h-9.5 w-9.5 bg-primary-900 flex justify-center items-center">
        <svg-icon
          src="assets/svg/bell.svg"
          [svgStyle]="{ width: 'auto', 'height.px': '24' }"
        ></svg-icon>
      </span>
    </a>

    <span class="w-36 h-9.5 rounded-full p-1.5 bg-primary-900">
      <a
        nz-dropdown
        nzTrigger="click"
        [nzDropdownMenu]="menu"
        class="flex items-center justify-between gap-2"
      >
        <span class="w-6.5! h-6.5! flex justify-center items-center">
          <nz-avatar
            [nzSize]="26"
            [nzText]="abbr"
            class="bg-indigo-50 text-primary-700 font-bold"
            [nzSrc]="authService.user()?.userProfile?.user?.avatarUrl"
          ></nz-avatar>
        </span>

        <p class="text-xs font-medium text-white truncate">
          {{ authService.user()?.userProfile?.user?.firstName }}
        </p>

        <svg-icon src="assets/svg/chevron-down.svg" class="text-white"></svg-icon>
      </a>

      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu class="w-45">
          @for (item of dropdownMenuList(); track $index) {
            @if (item.subMenuList && item.subMenuList.length > 0) {
              <li nz-submenu [nzTitle]="dropdownSubmenuTitle">
                <ng-template #dropdownSubmenuTitle>
                  <span class="flex items-center gap-2">
                    <svg-icon
                      [src]="item.icon"
                      [svgStyle]="{ 'width.px': 16, height: 'auto' }"
                    ></svg-icon>
                    <span>{{ item.name }}</span>
                  </span>
                </ng-template>

                <ul>
                  @for (subItem of item.subMenuList; track $index) {
                    <li
                      nz-menu-item
                      [nzDanger]="subItem.type === 'Danger' ? true : false"
                      (click)="dropdownMenuClickHandler(subItem)"
                      role="button"
                      class="[&_.ant-menu-title-content]:flex [&_.ant-menu-title-content]:items-center [&_.ant-menu-title-content]:gap-2"
                    >
                      <svg-icon
                        [src]="subItem.icon"
                        [svgStyle]="{ 'width.px': 16, height: 'auto' }"
                      ></svg-icon>
                      <p
                        [ngClass]="{
                          'text-[#ff4d4f]': subItem.type === 'Danger',
                        }"
                      >
                        {{ subItem.name }}
                      </p>
                    </li>
                  }
                </ul>
              </li>
            } @else {
              <li
                nz-menu-item
                [nzDanger]="item.type === 'Danger' ? true : false"
                (click)="dropdownMenuClickHandler(item)"
                role="button"
                class="[&_.ant-menu-title-content]:flex [&_.ant-menu-title-content]:items-center [&_.ant-menu-title-content]:gap-2"
              >
                <svg-icon
                  [src]="item.icon"
                  [svgStyle]="{ 'width.px': 16, height: 'auto' }"
                ></svg-icon>

                <p
                  [ngClass]="{
                    'text-[#ff4d4f]': item.type === 'Danger',
                  }"
                >
                  {{ item.name }}
                </p>
              </li>
            }
          }
        </ul>
      </nz-dropdown-menu>
    </span>
  </div>
</header>

<!-- *ngIf="!!authService.userData&&!hideRoutes -->
